import { useQuery } from '@apollo/client';
import { convertAddressAttributesToRestInput } from '../convertAddressAttributesToRestInput';
import { RestAddressAttributes } from '../fragments.rest';
import { VALIDATE_ADDRESS_QUERY } from './validateAddressQuery.rest';

export const useValidateAddressQuery = (attributes: RestAddressAttributes) => {
  const { data, loading, error } = useQuery(VALIDATE_ADDRESS_QUERY, {
    variables: {
      input: convertAddressAttributesToRestInput(attributes)
    }
  });
  return { address: data?.validateAddress.data[0], loading, error };
};
